var jq$ = jQuery.noConflict(true);
/* wrap everything inside jQueryMain or inside an instance of jQueryMain to avain using the original jquery*/

jq$(document).ready(function() {
    setTimeout(function() {
         $('.productMainBundle .bundleBuilder_title-desc.onetime').trigger('click');
    }, 2000);

  /* initialize sliders */
  gallerySlider();
  heroAccordionSlider();
  
  featUgcSlider();
  featProdSlider();
  differenceTabSlider();
  upsellSlider();
  scienceMobSlider();
});


function scienceMobSlider() {
  if (jq$(window).width() < 767) {
      jq$(".text-column-science-backed-pdpv2 .sc-content-slider-option ").not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true
      });
      console.log('slickme');
    } else {
      console.log('do nothing');
      jq$(".text-column-science-backed-pdpv2 .sc-content-slider-option.slick-initialized ").slick('unslick');
    }
}
function heroAccordionSlider() {
  if (jq$(window).width() > 851) {
      console.log('do nothing');
      jq$(".hero-promo-pdpv2 .accordion-wrap-pdpv2.slick-initialized ").slick("unslick");
    } else {
      console.log('slickme');
      jq$(".hero-promo-pdpv2 .accordion-wrap-pdpv2 ").not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        responsive: [
          {
            breakpoint: 550,
            settings: {
              dots: true,
              arrows: false,
              slidesToShow: 1,
            },
          },
        ],
      });
    }
}
function featUgcSlider() {
  if (jq$(window).width() > 1200) {
      console.log('do nothing ugc');
      jq$(".feature-vid-ugc .vid-list.slick-initialized ").slick("unslick");
    } else {
      console.log('slickme ugc');
      jq$(".feature-vid-ugc .vid-list ").not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 2,
        dots: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: false,
              centerMode: true,
              centerPadding: "30px"
            },
          },
        ],
      });
    }
    
  }
function featProdSlider() {
  if (jq$(window).width() > 992) {
      console.log('do nothing');
      jq$(".feat-prods-pdpv2 .featuredBlocks__content.slick-initialized ").slick("unslick");
    } else {
      console.log('slickme');
      jq$(".feat-prods-pdpv2 .featuredBlocks__content ").not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              dots: true,
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  
}
function differenceTabSlider() {
  jq$(".overlay-yerba-pdpv2 .text-wrapper-all").not('.slick-initialized').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
  });
}
function gallerySlider() {
  jq$(".mob-gallery-wrap-dz .pdpv2-images-grid.dz-gallery").not('.slick-initialized').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    centerMode: true,
    centerPadding: "60px",
  });
}
function upsellSlider() {
    if (jq$(window).width() > 992) {
      jq$(".pdp-main-productv2 .upsell-wrap.slick-initialized").slick("unslick");
      console.log('upsell unslick');
    } else {
      console.log('upsell slick');
      jq$(".pdp-main-productv2 .upsell-wrap").not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        responsive: [
          {
            breakpoint: 550,
            settings: {
              dots: true,
              arrows: true,
              slidesToShow: 1,
            },
          },
        ],
      });
    }
  }
/* =========== 
 on resize of window, initialize slider
  ==============*/

jq$(window).resize(function() {
  gallerySlider();
  scienceMobSlider();
  heroAccordionSlider();  
  featUgcSlider();
  featProdSlider();
  differenceTabSlider();
  upsellSlider();
});


jq$(document).ready(function ($) {
  // add all to same gallery
  $(".dz-gallery a").attr("data-fancybox", "mygallery");
  
  // assign captions and title from alt-attributes of images:
  $(".dz-gallery a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".dz-gallery a").fancybox();

   $("#nutrition-popup").fancybox({
     openEffect	: 'elastic',
     closeEffect	: 'elastic',
     helpers : {
     title : {
     type : 'inside'
          }
       }
  });
  /* initial loads */
  
  $(".productMainBundle .bundle-click-btn").click(function(){
    $('.productMainBundle .bundleBuilder_title-desc.subscribe-desc').click();
  });
  
  /* sticky of add to cart on mobile */
  var mainBtn = $('.bundle-tablist');
  var mobileBtn = $('.productMainBundle .productMain__addToCartContainer, .productMainBundle .actions-dz');


    $(window).on('scroll', function() {
    var scrollTop = $(this).scrollTop();

    $('.bundle-tablist').each(function() {
        var topDistance = $(this).offset().top;

        if ( (topDistance+100) < scrollTop ) {
          mobileBtn.addClass('sticky');
          $('body').addClass('sticky');
        }else{
          mobileBtn.removeClass('sticky');
          $('body').removeClass('sticky');
        }
    });
  });

  /* on scroll counter feature */
  var a = 0;
  $(window).scroll(function() {

  var oTop = $('#num-counter-dzy').offset().top - window.innerHeight;
  if (a == 0 && $(window).scrollTop() > oTop) {
    $('.counter-value').each(function() {
      var $this = $(this),
        countTo = $this.attr('data-count');
      $({
        countNum: $this.text()
      }).animate({
          countNum: countTo
        },

        {

          duration: 2000,
          easing: 'swing',
          step: function() {
            $this.text(Math.floor(this.countNum));
          },
          complete: function() {
            $this.text(this.countNum);
            //alert('finished');
          }

        });
    });
    a = 1;
  }

  });

  /* accordion slide */
  $('.acc-title.accordion-dz').click(function(){
    $(this).toggleClass('active');
    $(this).parent().find('.panel-dz.acc-cnt').slideToggle(280);
  });

  /* for offers page and functions */
  $('.plus-btn').click(function(){
    /* check current quantity */
    var currentQty = $('.prod-list').attr('data-count');
    var clickedQty = $(this).siblings('.num-qty').text();
    var minmax = $('.prod-list').attr('data-minmax');
    var minmax_type = $('.prod-list').attr('data-minmax-type');
    var totalprice = $('.prod-list').attr('data-total');
    var price = $(this).parent().parent().attr("data-price");

    if(minmax_type == 'maxbase'){
      if(currentQty < minmax){
        if(clickedQty <= minmax){
          var clickPlus = ++clickedQty
          $(this).parent().parent().addClass('active');
          $(this).siblings('.num-qty').text(clickPlus);
          $(this).parent().parent().attr('data-qty', clickPlus);
        }
        $('.prod-list').attr('data-count',++currentQty);
        addLinks();
      }
      if(currentQty == minmax){
        $('#offer-step2').addClass('active');
        
      }else{
        $('#offer-step2').removeClass('active');
      }
    }else{
      console.log('else minimum')


      var clickPlus = ++clickedQty
      $(this).parent().parent().addClass('active');
      $(this).siblings('.num-qty').text(clickPlus);
      $(this).parent().parent().attr('data-qty', clickPlus);

      $('.prod-list').attr('data-count',++currentQty);
      addLinks();

      if(currentQty >= minmax){
        $('#offer-step2').addClass('active');
      }else{
        $('#offer-step2').removeClass('active');
      }
    }
    var totalprice = parseFloat(totalprice) + parseFloat(price);
    $(".prod-list").attr('data-total', totalprice.toFixed(2));
    //console.log('total'+totalprice);
    $(".dynamic-compare").text('$'+totalprice.toFixed(2));
  });

  $('.minus-btn').click(function(){
    /* check current quantity */
    var currentQty = $('.prod-list').attr('data-count');
    var clickedQty = $(this).siblings('.num-qty').text();
    var minmax = $('.prod-list').attr('data-minmax');
    var minmax_type = $('.prod-list').attr('data-minmax-type');
    var totalprice = $('.prod-list').attr('data-total');
    var price = $(this).parent().parent().attr("data-price");
    
    if(currentQty > 0){
      if(clickedQty >= 1){
        var clickMinus = --clickedQty;
        $(this).siblings('.num-qty').text(clickMinus);
        $(this).parent().parent().attr('data-qty', clickMinus);
      }
      if(clickedQty == 0){
        $(this).parent().parent().removeClass('active');
      }
      $('.prod-list').attr('data-count',--currentQty);
      addLinks();
    }
    if(minmax_type == 'maxbase'){
      if(currentQty == minmax){
        $('#offer-step2').addClass('active');
      }else{
        $('#offer-step2').removeClass('active');
      }
    }else{
      if(currentQty >= minmax){
        $('#offer-step2').addClass('active');
      }else{
        $('#offer-step2').removeClass('active');
      }
    }
    var totalprice = parseFloat(totalprice) - parseFloat(price);
    $(".prod-list").attr('data-total', totalprice.toFixed(2));
    //console.log('total'+totalprice);
    $(".dynamic-compare").text('$'+totalprice.toFixed(2));
    
  });
  
  $('#offer-step2').click(function(e){  
    e.preventDefault();
    var minmax = $('.prod-list').attr('data-minmax');
    var minmax_type = $('.prod-list').attr('data-minmax-type');
    var currentQty = $('.prod-list').attr('data-count');

    if($(this).hasClass('active')){
      if(minmax_type == 'maxbase'){
        if(currentQty == minmax){
          $('.offers-bundle .step1').removeClass('active');
          $('.offers-bundle .step2').addClass('active');
        }
        
      }else{
        $('.offers-bundle .step1').removeClass('active');
        $('.offers-bundle .step2').addClass('active');
      }
    }
    updatePlans();
    clearCart();
      
    
  });
  $('.offer-backlink').click(function(e){  
    e.preventDefault();

    $('.offers-bundle .step1').addClass('active');
    $('.offers-bundle .step2').removeClass('active');
    
  });
  $('.offers-bundle .box-wrap').click(function(e){  
    $('.offers-bundle .box-wrap').removeClass('active');
    $(this).addClass('active');
    addLinks();
  });
  function updatePlans(){
    var totalprice = $('.prod-list').attr('data-total');
    $('.product-select-wrap .box-wrap').each(function(index, el) {
      var discount = $(this).attr("data-rate");
      var discountRate = ((parseFloat(totalprice)) * (parseFloat(discount))) / 100;
      var discountPrice = (parseFloat(totalprice)) - (parseFloat(discountRate));
      //console.log('discountrate:'+discountRate);
      $(this).children().find('.display-price').text('$'+discountPrice.toFixed(2));
    });
  }
  function addLinks(){
    var minmax = $('.prod-list').attr('data-minmax');
    var minmax_type = $('.prod-list').attr('data-minmax-type');
    var currentQty = $('.prod-list').attr('data-count');
    if(minmax_type == 'maxbase'){
      if(currentQty == minmax){
        $('.prod-list').addClass('max-active');
      }else{
        $('.prod-list').removeClass('max-active');
      }
      
    }
    var selectedProdArray = [];
    
    $('.prodselect.active').each(function(index, el) {
      let checkout_url = 'https://mateina.ca/cart/add?';
      
      var variant = $( this ).attr("data-id");
      var qty = $(this).attr("data-qty");
      var selling_plan = $(this).attr("data-plan");
      var minmax_type = $('.prod-list').attr('data-minmax-type');

      // free items
      var bundle = $(this).attr("data-bundled-variant-ids"); //bundle added to the li element, in case if in the future, item will be different for each block
      var bundles = bundle.split(",");
      var bundle_items = [];
      if(bundle_items.length > 0){
        for (var i = 0; i < bundles.length; i++) {
          bundle_items.push('&items[][id]=' + bundles[i] + "&items[][quantity]=1");
        }
      }else{
        bundle_items = '';
      }

      if ($("#subscribe-option").hasClass("active")) {
        var Discount = $("#subscribe-option").attr('data-discount');
      }else{
        var Discount = $("#onetime-option").attr('data-discount');
      }
      if(Discount != ''){
        var addDiscount = '?discount='+Discount;
      }else{
        var addDiscount = '';
      }
      console.log(addDiscount);

      if(qty == minmax && minmax_type == 'maxbase'){ //this means, same product was selected
        // https://drinkmateina.com/cart/add?items[][id]=47248603971897&items[][quantity]=2&items[][selling_plan]=690682233145&return_to=/checkout
        //cart/clear?return_to=/cart/add?items[][id]={VARIANT_ID}%26items[][quantity]={QUANTITY}%26items[][selling_plan]={SELLING_PLAN_ID}%26return_to=/checkout
        //https://drinkmateina.com/cart/clear?return_to=/cart/add?items[][id]=47248603971897%26items[][quantity]=2%26items[][selling_plan]=690682233145%26return_to=/checkout
        
        if ($("#subscribe-option").hasClass("active")) {
          console.log('sub has');
          if(selling_plan != ''){
            var selling = '&items[][selling_plan]='+selling_plan;
            console.log
          }else{
            var selling = '';
          }
        }

        var singleProd = 'items[][id]=' + variant;
        var quantity = '&items[][quantity]=' + qty;
        checkout_url = checkout_url + singleProd + quantity + selling + bundle_items + '&return_to=/checkout' + addDiscount ;
        //var checkoutlink = "https://drinkmateina.com/cart/clear?return_to=/cart/add?items[][id]=47248603971897%26items[][quantity]=2%26items[][selling_plan]=690682233145%26return_to=/checkout";
        $("#offer-checkout").attr("href",checkout_url);
      
      }else{
        selectedProdArray[index] = [];
        var mSellplan = $('#prod-'+variant).attr('data-plan');
        var qty = $('#prod-'+variant).attr('data-qty');
        if ($("#subscribe-option").hasClass("active")) {
          console.log('sub has');
          if(mSellplan != ''){
            var mSelling = '&items[][selling_plan]=' +mSellplan;
          }else{
            var mSelling = '';
          }
        }else{
          var mSelling = '';
        }
        var quantity = '&items[][quantity]=' + qty;
        selectedProdArray[index].push('items[][id]='+ variant + quantity + mSelling);
        
        var multipleProd = selectedProdArray.join('&');

        //console.log(multipleProd);
        checkout_url = checkout_url + multipleProd + bundle_items + '&return_to=/checkout' + addDiscount;
        $("#offer-checkout").attr("href",checkout_url);
        
      }

    });
    
    
    
  }
  $('#offer-checkout').click(function(e) {
      
      var checkoutlink = $(this).attr("href");
      window.location.href = checkoutlink;
    });
  function clearCart() {
    fetch('/cart/clear.js', { method: 'POST' })
      .then(() => {
        console.log('Your cart has been cleared!');
      })
      .catch((error) => {
        console.error('Error clearing cart:', error);
      });
  }
});



